<div class="container">
  <div class="row mt-3 mb-4" >
    <div class="col-12 header-text">
      Support
    </div>
  </div>
    <div class="row mb-5">
      <div class="col-6">
        <span class="sub-header-text">Forms vary by state. Select your state to view the appropriate forms:</span>
      </div>
      <div class="col-6">
        <select name="state" id="state" class="form-control" (change)="stateChanged($event)" [ngModel]="stateAbbr" *ngIf="em.allowedStates.length > 0">
          <option value="none">SELECT STATE</option>
          <option value="{{state.abbr}}" *ngFor="let state of em.allowedStates">{{state.name}}</option>
        </select>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-lg-12 col-12 mb-5">
        <div class="card-box">
          <div class="row">
            <div class="col-12">
              <p class="support-header-text mb-3">Membership Agreement</p>
              <p class="support-text">
                Wellfit Plans is required to provide prospective members a copy of the Membership Agreement prior to enrollment.
                Simply click the PDF links below to view/print the agreement or fee schedule.
              </p>
            </div>
          </div>
          <div class="row" *ngIf="stateChosen">
            <div class="col-12">
              <label class="summary-link" (click)="openUrl('currFees')"><img src="assets/images/Group%20527.png" alt=""> 2025 Membership Agreement <img src="assets/images/down.png" alt=""></label> <br>
              <label class="summary-link" (click)="openUrl('currDiscount')"><img src="assets/images/Group%20527.png" alt=""> 2025 Plan Fee Schedule <img src="assets/images/down.png" alt=""></label>
              <br><br>
              <label class="summary-link" (click)="openUrl('prevFees')"><img src="assets/images/Group%20527.png" alt=""> 2024 Membership Agreement <img src="assets/images/down.png" alt=""></label> <br>
              <label class="summary-link" (click)="openUrl('prevDiscount')"><img src="assets/images/Group%20527.png" alt=""> 2024 Plan Fee Schedule <img src="assets/images/down.png" alt=""></label>
            </div>
          </div>
          <div class="row mt-3 mb-3" *ngIf="em.isAdminBy == 'careingtonca'">
            <div class="col-12">
              <span class="sub-text">For information regarding ancilary benefits including UNOA please <a href="/benefit-info">click here</a>.</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="support-header-text mb-3">Cancellation & Refund Policy</p>
              <p class="support-text">
                The cancellation and refund policy can be found in the Membership Agreement.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="support-header-text mb-3">Grievances Form</p>
              <p class="support-text">
                If you have a grievance, complete and submit the online grievance form, <a routerLink="/greivance">here</a>.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="support-header-text mb-3">Have questions? Our plans specialists would love to help you.</p>
              <p class="support-text">
                Our Smile Generation Dental Plan® customer service team is here to support you and answer any questions you may have. Please feel free to contact us at
                {{info.telephoneNumber | phone}}
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

